import { LiliMask } from '@lili/lili-frontend-common';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { OnboardingFormFields } from '@Types/index';
import eyeIcon from '@Assets/icons/eye.svg';
import eyeVisibleIcon from '@Assets/icons/eye-visible.svg';
import { ControlledMaskedInput } from './ControlledInputs';

interface SSNInputProps {
  tabIndex?: number;
}

export const SSNInput = ({ tabIndex }: SSNInputProps = {}) => {
  const [isVisible, setIsVisible] = useState(true);
  const { t } = useTranslation();

  const einHideSlot = () => {
    return (
      <button
        onClick={() => setIsVisible((prevState) => !prevState)}
        className='z-50 absolute top-[16px] right-[16px] h-[24px] w-[24px] flex items-center justify-center'>
        <img
          alt='hide'
          className='w-full object-cover'
          src={isVisible ? eyeIcon : eyeVisibleIcon}
        />
      </button>
    );
  };

  useEffect(() => {
    const ssnInput = document.getElementById(OnboardingFormFields.SSN) as HTMLInputElement;
    if (ssnInput) {
      ssnInput.type = isVisible ? 'text' : 'password';
      ssnInput.setAttribute('autocomplete', 'off');
    }
  }, [isVisible]);

  return (
    <ControlledMaskedInput
      name={OnboardingFormFields.SSN}
      mask={LiliMask.SSN}
      id={OnboardingFormFields.SSN}
      title={t('pages.identity.ssnFieldTitle')}
      props={{ showClear: false }}
      isPublic={false}
      accessoryItemComponent={einHideSlot()}
      tabindex={tabIndex}
    />
  );
};
